import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useAnalytics } from '@Shared/useAnalytics';

const CarValueWrapper = styled.div`
  background-color: ${props => props.theme.carvana.gray.background};
  border-left: 3px solid ${props => props.theme.carvana.green.primary};
  border-radius: 3px;
  padding: 10px 15px;
  width: 233px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    width: 213px;
  }
`;

const Price = styled.span`
  color: ${props => props.theme.carvana.blue.primary};
  font-size: 30px;
  font-weight: 400;
  letter-spacing: -0.91px;
`;

const Title = styled.div`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
`;

const ViewDetails = styled.a`
  color: ${props => props.theme.carvana.blue.primary};
  font-size: 14px;
  font-weight: 400;

  &:hover {
    color: ${props => props.theme.carvana.blue.hover};
    text-decoration: none;
  }
`;

const DollarSign = styled.sup`
  font-size: 15px;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
  top: -0.65em;
`;


const CarValueCard = ({ trade }) => {
  const { trackEventAndGo } = useAnalytics();

  return (
    <CarValueWrapper
      data-cv-test="headerCarValueWidget"
      className={trade.className}
    >
      <Price>
        <DollarSign>$</DollarSign>
        {trade.tradeValue}
      </Price>
      <Title>{trade.yearMakeModel}</Title>
      <ViewDetails
        data-cv-test="headerCarValueLink"
        href="/trades"
        target="_self"
        onClick={e => trackEventAndGo(e, 'clicked trade widget')}
      >
        Offer Details
      </ViewDetails>
    </CarValueWrapper>
  );
};

CarValueCard.defaultProps = {
  trade: null
};

CarValueCard.propTypes = {
  trade: PropTypes.shape({})
};

export default CarValueCard;
